import React from 'react'
import DeleteIcon from "@material-ui/icons/Delete";
import {
    TablePagination,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    Box,
    makeStyles,
    Typography,
    ButtonGroup,
    InputBase,
    withStyles,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Grid,
    TextField


} from "@material-ui/core";
import OrderDetail from './orderDetail';
import ServiceOrderDetail from './serviceOrderDetail';

export function JobseekerPurchaseHistory({id, setSelectedJobSeeker}){
    const [pending, setPending] = React.useState(false)
    
    return <>
        <Dialog
            open={true}
            onClose={()=>{
                setSelectedJobSeeker(null)
            }}
            aria-labelledby="form-dialog-title"
            maxWidth="lg"
            fullWidth="100%"
        >
            {/* <DialogTitle id="form-dialog-title">
                <Typography variant="h6">{selectedJobSeeker.invitedBy ? "Update Coach" : 'Assign Coach'}</Typography>
            </DialogTitle> */}
            <DialogContent>
                <OrderDetail id={id} />
                <ServiceOrderDetail id={id} />
            </DialogContent>

            <DialogActions>
                <Button
                    size="large"
                    onClick={()=>{
                        setSelectedJobSeeker(null);
                    }}
                    variant={"contained"}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    </>
}